<div class="mech-diag-content">
	<app-dvs-chart [error]="errormessage" [options]="spectrumxoptions"></app-dvs-chart>
	<app-dvs-chart [error]="errormessage" [options]="spectrumyoptions"></app-dvs-chart>
	<app-dvs-chart [error]="errormessage" [options]="spectrumzoptions"></app-dvs-chart>
</div>